import { AfterViewChecked, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { LogMessage } from 'src/app/@core/models/infrastructure/LogMessage.model';
import { DarkModeService } from 'src/app/@core/services/dark-mode/dark-mode.service';
import { RxService } from 'src/app/@core/services/rx/rx.service';

@Component({
  selector: 'app-container-logs',
  templateUrl: './container-logs.component.html',
  styleUrls: ['./container-logs.component.scss'],
})

export class ContainerLogsComponent implements OnInit, AfterViewChecked, OnDestroy {
  @ViewChild('scroll') private myScrollContainer: ElementRef;
  
  sse: Subscription;
  logMessage$: LogMessage[] = [];

  constructor(private service: RxService, public darkModeService: DarkModeService) { }

  ngAfterViewChecked(): void {
    this.scrollToBottom();
  }

  ngOnInit() {
    this.loadLogMessages();
  }

  ngOnDestroy(): void {
    if (this.sse) {
      this.sse.unsubscribe();
    }
  }

  loadLogMessages() {
    if (this.sse) {
      this.sse.unsubscribe();
    }
    this.logMessage$ = [];
    this.sse = this.service.getLogMessagesStream().subscribe((message) => {
      this.logMessage$.push(message);
    });
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch(err) { }                 
  }

}
